import React, { useState } from "react";
import { browserLocalPersistence } from "firebase/auth";
import { useForm } from "react-hook-form";
import { signIn } from "../authentication/authContext";
import { useNavigate } from "react-router";

export default function LoginForm() {
  const {
    register,
    handleSubmit,
    setError,
    clearErrors,
    formState: { errors},
  } = useForm(); // Enable validation on change

  const [loading, setLoading] = useState(false);
  const navigate = useNavigate();

  const onSubmit = async (data) => {
    setLoading(true);

    try {
      await signIn(data, browserLocalPersistence);
      navigate("/", { replace: true });
    } catch (err) {
      setError("form", {
        type: "manual",
        message: err.message || "Login failed",
      });
    } finally {
      setLoading(false);
    }
  };

  return (
    <form className="login-form" onSubmit={handleSubmit(onSubmit)}>
      <h2>Login</h2>

      <input
        type="email"
        placeholder="Email"
        {...register("email", { required: "Email is required" })}
      />
      {errors.email && <p className="error-text">{errors.email.message}</p>}

      <input
        type="password"
        placeholder="Password"
        {...register("password", { required: "Password is required" })}
      />
      {errors.password && (
        <p className="error-text">{errors.password.message}</p>
      )}

      {errors.form && <p className="error-text">{errors.form.message}</p>}

      <button type="submit" disabled={loading} onClick={() => clearErrors("form")}>
        {loading ? "Logging in..." : "Login"}
      </button>
    </form>
  );
}